import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../components/Checkbox";
import { getCompanyById } from "../../../../services/company.service";

const Row = ({ item, selected, onSelect }) => {
    const navigate = useNavigate();
    const mainContact = item.contacts?.[0] || {};

    const handleRowClick = async () => {
        try {
            const companyData = await getCompanyById(item.id);
            navigate(`/admin/companies/${item.id}`, { state: { company: companyData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données de l\'entreprise:', error);
            navigate(`/admin/companies/${item.id}`, { state: { company: item } });
        }
    };

    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={selected}
                        onChange={(e) => {
                            e.stopPropagation();
                            onSelect && onSelect(item.id);
                        }}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <img src={item.logoUrl || '/images/content/company_logo.png'} alt="Logo" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{item.name}</div>
                            <div className={styles.login}>{item.sector}</div>
                            <div className={styles.email}>{mainContact.email}</div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.email}</div>
                    <div className={styles.email}>{item.phone}</div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn('status-type', 'status-blue-dark')}>
                        {item.type_of_company}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn('status-type', 'status-green-dark')}>
                        {item.employee_count}
                    </div>
                </div>

            </div>
        </>
    );
};

export default Row;
